export default function () {
  return {
    regulamentos: {
      data: [],
    },
    regulamento: {
      attributes: {
        titulo: '',
      },
      relationships: {
        contextox: [],
      },
    },
  };
}
